type Props = {
  title: string
  subtitle?: string | null
}

export default function ScreenTitle({ title }: Props) {
  return (
    <div className="w-full">
      <div className="mx-auto max-w-3xl grow">
        <div className="min-w-full grow">
          <p className="text-xl font-medium tracking-tight text-gray-900 sm:text-2xl">
            {title}
          </p>
        </div>
      </div>
    </div>
  )
}
